import { render, staticRenderFns } from "./newTariftable.vue?vue&type=template&id=97a029ea&"
import script from "./newTariftable.vue?vue&type=script&defer=true&lang=js&"
export * from "./newTariftable.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./newTariftable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports